<script>
  import MinimalCombobox from "./MinimalCombobox.svelte";
  import { outlookChangeTaskStatus } from "../../../../components/dashboard/outlook/outlook.js";
  import { onMount } from "svelte";

  export let task;
  export let onOpen;
  export let onChange;

  let statusOptions = [
    { value: "todo", label: "To do" },
    { value: "inprogress", label: "In progress" },
    { value: "done", label: "Done" },
  ];

  let statusOptionsSelected = null;

  let loading = true;

  onMount(() => {
    changeStatusCombo();

    setTimeout(() => {
      loading = false;
    }, 500);
  });

  let changeStatus = () => {
    task.status = statusOptionsSelected.value;

    outlookChangeTaskStatus(
      task,
      statusOptionsSelected.value,
      () => {
        onChange();
      },
      () => {}
    );
  };

  let changeStatusCombo = () => {
    statusOptionsSelected = statusOptions.find((item) => {
      return item.value === task.status;
    });
  };

  $: if (task && !loading) {
    changeStatusCombo();
  }
</script>

<div class="taskContainer">
  <div
    class="taskInfo {task.notes !== '' ? 'withNotes' : ''}"
    on:click={() => {
      if (task.notes) {
        onOpen();
      }
    }}
  >
    <div class="taskInfoName">
      {#if task.notes}
        <img class="notesIcon" src="/images/notes.svg" alt="Notes Icon" />
      {/if}
      <span class="taskName">{task.title || task.name}</span>
    </div>
    <!-- svelte-ignore missing-declaration -->
    {#if task.end}
      <span class="taskDate"
        >{moment(task.end, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")}</span
      >{/if}
  </div>
  <div class="taskStatus">
    <div class="combobox">
      <MinimalCombobox
        bind:selectedValue={statusOptionsSelected}
        options={statusOptions}
        backgroundColor="white"
        onChange={() => {
          if (!loading) {
            changeStatus();
          }
        }}
      />
    </div>
  </div>
</div>

<style>
  div.taskContainer {
    display: flex;
    flex-direction: row;
    width: 100%;
    min-height: 32px;
    border-bottom: 1px solid #e7e7e7;
    padding: 3px;
  }

  div.taskInfo {
    display: flex;
    flex-direction: column;
    width: 85%;
  }

  div.withNotes {
    cursor: pointer;
  }

  .taskDate {
    font-size: 12px !important;
    color: var(--labit-dashboard-light-gray) !important;
  }

  .combobox {
    height: 17px;
    width: 29px;
  }

  div.taskInfoName {
    display: flex;
    align-items: flex-start;
  }

  img.notesIcon {
    height: 13px;
    margin: 3px 3px 0 0;
  }
</style>
